<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-toc" id="table-of-contents">
<div class="toc-heading"><h3 class="toc-title">Contents</h3></div>
<div class="toc-contents">
<div class="toc-bodymatter-group">
<div class="toc-volume-group has-no-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/vol001"><span class="element-title-text">Spirits Revived</span></a></p>
</div>
</div>
<div class="toc-volume-group has-no-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/vol002" title="Link target outside of Sample"><span class="element-title-text">Dark Spirits</span></span></p>
</div>
</div>
<div class="toc-volume-group has-no-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/vol003" title="Link target outside of Sample"><span class="element-title-text">Spirits Onstage</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f2bb11fe